module.exports = __webpack_public_path__ + "img/gamechanger-bolt--purple.22e2077b.svg";